import { useTranslation } from 'react-i18next'

import { GENERATOR_INPUT_TYPE } from '@constants'

export const useInputs = () => {
  const { t } = useTranslation()

  const centerInputs = [
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'center.latitude',
      label: t('mapCreateOrEdit.centerLat'),
      placeholder: t('mapCreateOrEdit.centerLatPlaceholder'),
      type: 'number',
      rules: { required: true },
      gridProps: { xs: 6 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'center.longitude',
      label: t('mapCreateOrEdit.centerLng'),
      placeholder: t('mapCreateOrEdit.centerLngPlaceholder'),
      type: 'number',
      rules: { required: true },
      gridProps: { xs: 6 },
    },
  ]

  const zoomInput = [
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'zoom',
      label: t('mapCreateOrEdit.zoom'),
      placeholder: t('mapCreateOrEdit.zoomPlaceholder'),
      type: 'number',
      rules: { required: true, min: 1, max: 20 },
      gridProps: { xs: 12 },
    },
  ]

  const maxBoundsInputs = [
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'maxBounds.swLatitude',
      label: t('mapCreateOrEdit.maxBoundsSwLat'),
      placeholder: t('mapCreateOrEdit.maxBoundsSwLatPlaceholder'),
      type: 'number',
      rules: { required: true },
      gridProps: { xs: 6 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'maxBounds.swLongitude',
      label: t('mapCreateOrEdit.maxBoundsSwLng'),
      placeholder: t('mapCreateOrEdit.maxBoundsSwLngPlaceholder'),
      type: 'number',
      rules: { required: true },
      gridProps: { xs: 6 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'maxBounds.neLatitude',
      label: t('mapCreateOrEdit.maxBoundsNeLat'),
      placeholder: t('mapCreateOrEdit.maxBoundsNeLatPlaceholder'),
      type: 'number',
      rules: { required: true },
      gridProps: { xs: 6 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'maxBounds.neLongitude',
      label: t('mapCreateOrEdit.maxBoundsNeLng'),
      placeholder: t('mapCreateOrEdit.maxBoundsNeLngPlaceholder'),
      type: 'number',
      rules: { required: true },
      gridProps: { xs: 6 },
    },
  ]

  return {
    centerInputs,
    zoomInput,
    maxBoundsInputs,
  }
}
